import React, { useEffect, useState, useRef } from 'react'

import clsx from 'clsx'

import Drawer from 'components/Drawer'
import useViewport from 'hooks/useViewport'

import NavigationList from '../NavigationList'

import classes from './Sidebar.module.scss'

/** @type {import("./types").default} */
const Sidebar = ({ navSections, ...moreProps }) => {
  const mdNavigationAnchorElement = useRef(null)
  const [selectedMenuItem, setSelectedMenuItem] = useState('')
  const [state, setState] = useState({ isDrawerOpen: false, drawerOffsetTop: 136 })
  const { is, up } = useViewport()

  useEffect(() => {
    const observerCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setSelectedMenuItem(entry.target.id)
        }
      })
    }
    const observer = new IntersectionObserver(observerCallback, {
      rootMargin: `-25% 0px -75% 0px`,
    })

    document.querySelectorAll('.sectionItem').forEach(element => observer.observe(element))

    return () => observer.disconnect()
  }, [])

  const closeDrawer = event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState({ ...state, isDrawerOpen: false })
  }

  const openDrawer = event => {
    setState({
      isDrawerOpen: true,
      drawerOffsetTop: mdNavigationAnchorElement.current.getBoundingClientRect().top,
    })
    event.stopPropagation()
  }

  return (
    <>
      {/* Show in >lg Desktop and Tablet */}
      {(is('sm') || up('lg')) && <NavigationList navSections={navSections} active={selectedMenuItem} {...moreProps} />}

      {/* Show only in Small Desktop (md) */}
      {is('md') && (
        <>
          <div
            ref={mdNavigationAnchorElement}
            onClickCapture={openDrawer}
            className={clsx({ [classes.hideSidebar]: state.isDrawerOpen })}
          >
            <NavigationList navSections={navSections} active={selectedMenuItem} {...moreProps} />
          </div>

          <Drawer
            anchor="left"
            open={state.isDrawerOpen}
            modalProps={{
              BackdropProps: { className: classes.drawerBackdrop },
              disableScrollLock: true,
            }}
            paperProps={{
              elevation: 0,
              className: classes.drawerPaper,
            }}
            onClose={closeDrawer}
          >
            <NavigationList
              navSections={navSections}
              classes={{ listLinkTypography: classes.drawerTypography }}
              isDrawerOpen={state.isDrawerOpen}
              active={selectedMenuItem}
              {...moreProps}
            />
          </Drawer>
        </>
      )}
    </>
  )
}

export default Sidebar
